import React, { useState } from "react";
import IconClose from "../Resources/svg/Icons/IconClose";
import ModalFiltering from "./FormElements/ModalFiltering";
import Button from "./FormElements/Button";

const ModalCapitalSimulation = ({
  openModal,
  setOpenModal,
  resultedAmount,
  calculated,
  typeAmount
}) => {

  const currencySymbol = (currency) => {
    if(currency === "USD" || currency === "Dólares") return "$."
    if(currency === "PEN" || currency === "Soles") return "S/."
  }

  return (
    <ModalFiltering
      className={`modal-result is-midle ${
        openModal && "is-open"
      }`}
    >
      <div
        className="modal-filtering__close"
        onClick={() => setOpenModal(false)}
      >
        <IconClose />
      </div>
      <h2 className="modal-result__title">Mensaje de Validación</h2>
      <div className="modal-result__desc">
        <p>La sumatoria del origen de fondo debe ser igual {typeAmount === "prima" ? `a la ${typeAmount}` : typeAmount === "acumulado" ? `al ${typeAmount}` : ""}:</p>
        <div className="modal-result__amount">
          <p><span>Tu {typeAmount} es </span> {resultedAmount && currencySymbol(resultedAmount.currency)}{resultedAmount && resultedAmount.amount.toFixed(2)}</p>
          <p><span>La sumatoria es </span> {calculated && currencySymbol(calculated.currency)}{calculated && calculated.amount.toFixed(2)}</p>
        </div>
      </div>
      <div className="actions">
        <Button
          type="submit"
          className={`actions__continue`}
          onClick={() => setOpenModal(false)}
        >
          Aceptar
        </Button>
      </div>
    </ModalFiltering>
  );
};

export default ModalCapitalSimulation;
